export function usePagePermission(){
  return useState<string[] | undefined>('pageRequiredPermissions', () => undefined)
}